/* Flourea Beauty — Theme JavaScript
   All class names match flourea-luxury.css exactly:
   .hdr, .is-stuck, .drawer, .drawer-scrim, .is-on, .toast
*/
'use strict';

/* ── Helpers ── */
const $ = id => document.getElementById(id);
const money = cents => {
  const n = (typeof cents === 'string' ? cents.replace('.','') : cents);
  return '$' + (n / 100).toFixed(2);
};
const show = (toast, msg) => {
  $('toast-msg').textContent = msg || 'Added to bag';
  toast.classList.add('is-on');
  setTimeout(() => toast.classList.remove('is-on'), 2800);
};

/* ── Sticky Header ── */
(function() {
  const hdr = $('site-hdr');
  if (!hdr) return;
  const onScroll = () => {
  hdr.classList.toggle('is-stuck', window.scrollY > 60);
  /* document.body.classList.toggle('is-scrolled', window.scrollY > 60);*/
};
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Mobile hamburger ── */
(function() {
  const burger  = $('hdr-burger');
  const nav     = $('mob-nav');
  const scrim   = $('mob-scrim');
  const closeBtn = $('mob-nav-close');
  if (!burger || !nav) return;

  // Show burger below 960px
  const mq = window.matchMedia('(max-width: 960px)');
  const toggle = on => {
    burger.style.display = on ? '' : 'none';
  };
  mq.addEventListener('change', e => toggle(e.matches));
  toggle(mq.matches);

  const open = () => {
    nav.classList.add('is-on');
    scrim && scrim.classList.add('is-on');
    burger.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    nav.classList.remove('is-on');
    scrim && scrim.classList.remove('is-on');
    burger.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  burger.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  scrim && scrim.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
})();

/* ── Search overlay ── */
(function() {
  const overlay  = $('search-overlay');
  const openBtn  = $('hdr-search-btn');
  const closeBtn = $('search-close');
  const scrim    = $('search-scrim');
  if (!overlay || !openBtn) return;

  const open = () => {
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    overlay.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    const inp = overlay.querySelector('input[name="q"]');
    if (inp) setTimeout(() => inp.focus(), 80);
  };
  const close = () => {
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
  };

openBtn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  scrim && scrim.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
})();

/* ── Cart drawer ── */
const CartDrawer = (function() {
  const drawer  = $('cart-drawer');
  const scrim   = $('cart-scrim');
  const closeBtn = $('cart-close');
  const itemsEl = $('cart-items');
  const footEl  = $('cart-foot');
  const subEl   = $('cart-subtotal');
  const countEl = $('hdr-cart-count');
  const toast   = $('flourea-toast');

  const open = () => {
    drawer && drawer.classList.add('is-on');
    scrim  && scrim.classList.add('is-on');
    drawer && drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-open');
    refresh();
  };
  const close = () => {
    drawer && drawer.classList.remove('is-on');
    scrim  && scrim.classList.remove('is-on');
    drawer && drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-open');
  };
  const updateCount = n => {
    if (!countEl) return;
    if (n > 0) { countEl.textContent = n; countEl.style.display = 'grid'; }
    else { countEl.style.display = 'none'; }
  };

  const renderItem = item => {
    const img = item.featured_image?.url
      ? `<img src="${item.featured_image.url}&width=160" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="ci__meta">${item.variant_title}</div>` : '';
    return `
      <div class="ci" data-key="${item.key}" data-qty="${item.quantity}">
        <div class="ci__media">${img}</div>
        <div>
          <p class="ci__name">${item.product_title}</p>
          ${variant}
          <div class="ci__qty">
            <button aria-label="Decrease" onclick="CartDrawer.qty('${item.key}',${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button aria-label="Increase" onclick="CartDrawer.qty('${item.key}',${item.quantity + 1})">+</button>
          </div>
          <a class="ci__remove" href="#" onclick="CartDrawer.qty('${item.key}',0);return false;">Remove</a>
        </div>
        <div class="ci__price">${money(item.final_line_price)}</div>
      </div>`;
  };

  const render = cart => {
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="drawer__empty">Your bag is empty.</div>';
      footEl && (footEl.style.display = 'none');
    } else {
      itemsEl.innerHTML = cart.items.map(renderItem).join('');
      if (footEl) footEl.style.display = '';
      if (subEl) subEl.textContent = money(cart.total_price);
    }
    updateCount(cart.item_count);
  };

  const refresh = async () => {
    try {
      const r = await fetch('/cart.js');
      render(await r.json());
    } catch(e) { console.error('Cart fetch error', e); }
  };

  const qty = async (key, q) => {
    try {
      /* ── If removing main item, check if it has a linked free gift ── */
      if (q === 0) {
        const cartData  = await fetch('/cart.js').then(r => r.json());
        const thisItem  = cartData.items.find(i => i.key === key);

        if (thisItem && thisItem.properties && thisItem.properties['_free_gift_handle']) {
          /* This is a main item with a free gift — find and remove the gift too */
          const giftHandle = thisItem.properties['_free_gift_handle'];
          const giftItem   = cartData.items.find(i =>
            i.properties &&
            i.properties['_is_free_gift'] === 'true' &&
            i.handle === giftHandle
          );
          if (giftItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftItem.key, quantity: 0 })
            });
          }
        }

        if (thisItem && thisItem.properties && thisItem.properties['_is_free_gift'] === 'true') {
          /* This is a free gift being removed — also remove the main item */
          const mainId   = thisItem.properties['_paired_main_id'];
          const mainItem = mainId
            ? cartData.items.find(i => String(i.variant_id) === String(mainId))
            : null;
          if (mainItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: mainItem.key, quantity: 0 })
            });
          }
        }
      }

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      });
      refresh();
    } catch (e) { console.error(e); }
  };

  /* Init */
  $('hdr-cart-btn') && $('hdr-cart-btn').addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  scrim && scrim.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  refresh(); // initialise count on load

  return { open, close, refresh, qty };
})();

/* ── Add to cart (form submit + quick-add buttons) ── */
document.addEventListener('submit', async function(e) {
  const form = e.target.closest('form[action="/cart/add"]') || e.target.closest('.prod form');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('[type="submit"], .prod__add');
  const originalText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

  try {
    const fd = new FormData(form);
    await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); }
    CartDrawer.open();
    show($('flourea-toast'), 'Added to your bag');
    setTimeout(() => {
      if (btn) { btn.textContent = originalText; btn.disabled = false; btn.classList.remove('is-added'); }
    }, 2200);
  } catch(err) {
    if (btn) { btn.textContent = 'Error'; btn.disabled = false; }
  }
});

/* ── Shopify section block clicks for quick-add ── */
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('[data-add-id]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.dataset.addId;
  const originalText = btn.textContent;
  btn.textContent = 'Adding…'; btn.disabled = true;
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
    btn.textContent = 'Added ✓'; btn.classList.add('is-added');
    CartDrawer.open();
    show($('flourea-toast'), 'Added to your bag');
    setTimeout(() => { btn.textContent = originalText; btn.disabled = false; btn.classList.remove('is-added'); }, 2200);
  } catch(err) {
    btn.textContent = 'Error'; btn.disabled = false;
  }
});

/* ── FAQ accordion (any .faq-item on page) ── */
document.addEventListener('click', function(e) {
  const head = e.target.closest('.faq-item__head');
  if (!head) return;
  const item = head.closest('.faq-item');
  if (!item) return;
  const isOpen = item.classList.contains('is-open');
  document.querySelectorAll('.faq-item.is-open').forEach(el => el.classList.remove('is-open'));
  if (!isOpen) item.classList.add('is-open');
});

/* ── Filter accordion on collection page ── */
document.addEventListener('click', function(e) {
  const head = e.target.closest('.col-filter__head');
  if (!head) return;
  head.closest('.col-filter')?.classList.toggle('is-open');
});

/* ── PDP accordion ── */
document.addEventListener('click', function(e) {
  const head = e.target.closest('.pdp-acc__head');
  if (!head) return;
  head.closest('.pdp-acc__item')?.classList.toggle('is-open');
});

/* ── Remove app-injected trust badges from featured products forms ────────
   Some Shopify apps (Vitals, Trust Badge Bear, etc.) use JavaScript to scan
   the page for <form action="/cart/add"> elements and inject trust badge HTML
   after the submit button, 1-3 seconds after page load.
   We use a MutationObserver to watch .fl-prods and immediately strip any
   element that gets injected into a form AFTER the submit button.          */
(function () {
  var grid = document.querySelector('.fl-prods');
  if (!grid) return;

  function stripInjected(form) {
    /* Keep: hidden inputs, the submit button (.prod__add), nothing else */
    Array.prototype.slice.call(form.children).forEach(function (el) {
      var tag  = el.tagName.toLowerCase();
      var type = (el.getAttribute('type') || '').toLowerCase();
      var keep = (tag === 'input' && type === 'hidden') ||
                 (tag === 'button' && type === 'submit') ||
                 el.classList.contains('prod__add');
      if (!keep) el.remove();
    });
  }

  /* Run once immediately on all existing forms */
  grid.querySelectorAll('form').forEach(stripInjected);

  /* Watch for any future DOM mutations inside the grid */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;           /* elements only */
        /* If the added node is inside a form, strip the whole form */
        var parentForm = node.closest('form');
        if (parentForm && grid.contains(parentForm)) {
          stripInjected(parentForm);
        }
        /* If the added node IS a form (unlikely but possible) */
        if (node.tagName === 'FORM' && grid.contains(node)) {
          stripInjected(node);
        }
      });
    });
  });

  observer.observe(grid, { childList: true, subtree: true });
})();



/* Mobile cart button */
var cartBtnMob = document.getElementById('hdr-cart-btn-mob');
if (cartBtnMob) {
  cartBtnMob.addEventListener('click', function(e) {
    e.stopPropagation();
    CartDrawer.open();
  });
}

/* Mobile utility dropdown */
var utilityBtn  = document.getElementById('hdr-utility-btn');
var utilityDrop = document.getElementById('hdr-utility-dropdown');
if (utilityBtn && utilityDrop) {
  utilityBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = utilityDrop.style.display === 'flex';
    utilityDrop.style.display = isOpen ? 'none' : 'flex';
    utilityBtn.setAttribute('aria-expanded', String(!isOpen));
  });
  document.addEventListener('click', function(e) {
    if (utilityDrop.style.display === 'flex' &&
        !utilityBtn.contains(e.target) &&
        !utilityDrop.contains(e.target)) {
      utilityDrop.style.display = 'none';
      utilityBtn.setAttribute('aria-expanded', 'false');
    }
  });
}